<script lang="ts" setup>
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

/**
 * A reusable circular button for GSheet components.
 * Used as a base for GSheetCloseButton and GSheetBackButton.
 */
defineProps<{
  disabled?: boolean
  icon?: IconDefinition
}>()

defineEmits<{
  click: [event: MouseEvent]
}>()
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    class="g-sheet-button flex items-center justify-center p-3
    gap-1 rounded-full transition-colors bg-grey-50 !hover:bg-grey-400"
    @click="$emit('click', $event)"
  >
    <slot>
      <GIcon
        v-if="icon"
        :icon="icon"
        class="g-sheet-button-icon text-navy"
      />
    </slot>
  </button>
</template>

<style>
.g-sheet-button {
  height: 30px;
  width: 30px;

  .g-sheet-button-icon {
    height: 14px;
    width: 14px;
  }

  @media screen and (min-width: 1024px) {
    height: 40px;
    width: 40px;

    .g-sheet-button-icon {
      height: 16px;
      width: 16px;
    }
  }
}
</style>
